import { Component, OnInit, Input } from '@angular/core';
import { Chart as ChartJS, ChartType, ChartOptions } from 'chart.js'; // Library
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'src/app/base/interfaces/chart'; // Interface
import { ContentService } from 'src/app/base/services/content/content.service';

ChartJS.register(ChartDataLabels);

@Component({
  selector: 'app-easysuite-charts',
  templateUrl: './easysuite-charts.component.html',
  styleUrls: ['./easysuite-charts.component.css']
})
export class EasysuiteChartsComponent implements OnInit {
  @Input() pageID: number;
  @Input() chart: Chart; // Interface

  allFieldsEmpty = false;
  chartDescription: string = '';
  pieChartData: any = { labels: [], datasets: [] };
  pieChartType: ChartType = 'pie';
  ChartDataLabels = ChartDataLabels;

  options: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'right' as const
      },
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 11
        },
        formatter: (value: any) => value + '%',
      }
    }
  };

  constructor(private contentService: ContentService) { }

  ngOnInit(): void {
  this.contentService.getChartData(this.chart.ChartID, this.pageID).subscribe((data: any) => {
    
    const validIndices: number[] = [];
    
    // Finding valid indexes (value > 0 and label other than "No Exposure Recorded")
    data.datasets[0].data.forEach((value: number, index: number) => {
      if (value > 0 && data.labels[index] !== "No Exposure Recorded") {
        validIndices.push(index);
      }
    });
    
    const filteredLabels = validIndices.map(i => data.labels[i]);
    const filteredData = validIndices.map(i => data.datasets[0].data[i]);
    const filteredColors = validIndices.map(i => data.datasets[0].backgroundColor[i]);
    
    this.pieChartData = {
      labels: filteredLabels,
      datasets: [{
        ...data.datasets[0],
        data: filteredData,
        backgroundColor: filteredColors
      }]
    };
    
    if (data.AllFieldsEmpty) {
      this.allFieldsEmpty = true;
      this.chartDescription = data.ChartDescription;
    }
  });
}
}